// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const barboach: PokeData = {
  "id": 339,
  "name": "barboach",
  "height": 4,
  "weight": 19,
  "base_experience": 58,
  "types": [
    PokeType.WATER,
    PokeType.GROUND
  ],
  "api_moves": [
    "water-gun",
    "earthquake",
    "fissure",
    "amnesia",
    "rest",
    "snore",
    "mud-slap",
    "magnitude",
    "future-sight",
    "mud-sport",
    "muddy-water",
    "water-sport",
    "water-pulse",
    "aqua-tail",
    "earth-power",
    "mud-bomb",
    "zen-headbutt"
  ],
  "moves": [
    "earthquake",
    "fissure",
    "mud-slap",
    "magnitude",
    "future-sight",
    "aqua-tail",
    "earth-power",
    "mud-bomb",
    "zen-headbutt",
    "liquidation",
    "whirlpool",
    "rain-dance",
    "aqua-cutter"
  ],
  "evolution_chain": {
    "id": 173,
    "item": null,
    "species": [
      {
        "name": "barboach",
        "order": 367,
        "types": [
          PokeType.WATER,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "whiscash",
        "order": 368,
        "types": [
          PokeType.WATER,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 339,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 46,
    "speed": 60,
    "ability_power": 48
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
